<template>
  <v-dialog :value="value" persistent width="500">
    <v-card color="kbLight">
      <v-toolbar class="kbPurple" dark flat>
        {{ $t('general.addANameToYourTemplate') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <template v-if="!isUpdateTemplateWarningVisible">
        <v-card-text>
          <v-form ref="form" @submit.prevent="">
            <v-row>
              <v-col cols="12" class="pb-0 pt-6">
                <v-text-field color="kbDarkBlue"
                              background-color="kbWhite"
                              :label="$t('general.templateName')"
                              :rules="[rules.required]"
                              solo
                              v-model="templateName">
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="d-flex align-center justify-end">
          <v-btn
            color="kbPurple"
            class="mr-1"
            outlined
            small
            @click="toggleModal()">
            {{ $t('general.cancel') }}
          </v-btn>

          <v-btn
            color="kbPurple"
            dark
            small
            @click="checkTemplateExistence()">
            {{ $t('general.save') }}
          </v-btn>
        </v-card-actions>
      </template>

      <template v-else>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex flex-column align-center">
              <div>
                <p class="kbDarkBlueText--text text-center">
                  {{ $t('general.updateTemplateWarning', { templateName: this.templateName }) }}
                </p>
              </div>
              <div class="d-flex justify-center align-center">
                <v-btn
                  color="kbPurple"
                  class="mr-1"
                  outlined
                  small
                  @click="toggleUpdateTemplateWarning(false)">
                  {{ $t('general.cancel') }}
                </v-btn>

                <v-btn
                  color="kbPurple"
                  dark
                  small
                  @click="updateTemplate()">
                  {{ $t('general.update') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </template>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapState({
      selectedTemplate: state => state.campaigns.selectTemplate
    })
  },
  data () {
    return {
      isUpdateTemplateWarningVisible: false,
      rules,
      templateIdToUpdate: '',
      templateName: ''
    }
  },
  methods: {
    async checkTemplateExistence () {
      if (!this.$refs.form.validate()) return
      try {
        const response = await this.$store.dispatch('getTemplatesByName', this.templateName)
        if (response.templates && response.templates.count) {
          const foundTemplate = response.templates.rows.find(item => item.name.toLowerCase() === this.templateName.toLowerCase())
          if (foundTemplate) {
            this.setTemplateIdToUpdate(response.templates.rows[0]._id)
            this.toggleUpdateTemplateWarning(true)
          } else {
            this.saveTemplate()
          }
        } else {
          this.saveTemplate()
        }
      } catch (e) {
        notifications.error(e)
      }
    },
    saveTemplate () {
      this.$emit('onSaveEmailTemplate', this.templateName)
      this.toggleModal()
    },
    setTemplateIdToUpdate (templateId) {
      this.templateIdToUpdate = templateId
    },
    setTemplateName () {
      if (this.selectedTemplate &&
        typeof this.selectedTemplate === 'object' &&
        this.selectedTemplate.name) {
        this.templateName = this.selectedTemplate.name
      } else {
        this.templateName = ''
      }
    },
    toggleModal () {
      this.$emit('input', false)
    },
    toggleUpdateTemplateWarning (value) {
      this.isUpdateTemplateWarningVisible = value
    },
    updateTemplate () {
      this.$emit('onUpdateEmailTemplate', this.templateIdToUpdate)
      this.toggleUpdateTemplateWarning(false)
      this.templateIdToUpdate = ''
      this.toggleModal()
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value) {
        this.setTemplateName()
      }
    }
  }
}
</script>
